<template>
      <a-tree
        v-model="checkedKeys"
        defaultExpandAll
        :expanded-keys="expandedKeys"
        :auto-expand-parent="autoExpandParent"
        :selected-keys="selectedKeys"
        :tree-data="treeData"
        @expand="onExpand"
        @select="onSelect"
    >
        <template slot="custom" slot-scope="item">
            <div class="tree-slot">
                <span>{{item.title}}</span>
                <span v-if="item.num && item.num <= 99" class="tips">{{item.num}}</span>
                <span v-if="item.num > 99" class="tips">99+</span>
            </div>
        </template>
        </a-tree>
</template>
<script>

import {mapMutations} from 'vuex'

import {getDeptTree} from '@/api/back.js'


export default {
  data() {
    return {
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      treeData: [],
      root: false,
      rootId: null
    };
  },
  props: {
    deptId: Number
  },
  watch: {
    checkedKeys(val) {
      console.log('onCheck', val);
    },
  },
  created() {
    this.getDeptData()
  },
  methods: {
    ...mapMutations({
       setDeptTree: 'back/setDeptTree'
    }),
    async getDeptData() {
      const {data} = await getDeptTree()
      this.expandedKeys = []
      if(data?.length) {
        this.rootId = data[0].deptId
        this.expandedKeys.push(this.rootId)
        this.onSelect([this.rootId])
        this.treeData = this.recursion(data)
        this.setDeptTree(this.treeData)
      }
    },
    recursion(list) {
      list.forEach((item) => {
        item.key = item.deptId
        item.value = item.deptId
        item.title = item.deptName
        item.scopedSlots = { title: "custom" }
        if (item.children && item.children.length) {
          this.recursion(item.children)
        }
      })
      return list
    },
    getTreeList(list, id) {
      return list.reduce((pre, cur) => {
        if (cur.parentId === id) {
          const children = this.getTreeList(list, cur.deptId);
          if (children.length) {
            cur.children = children;
          }
          pre.push(cur);
        }
        return pre;
      }, []);
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys) {
    if(selectedKeys.length) {
      this.selectedKeys = selectedKeys;
      this.$emit('onSelect', selectedKeys)
    }
    },
  },
};
</script>